import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'
import {getUeCcVariationCodeAdjustedTime, useOrderChangeContext} from '@hconnect/tuc-processes/orderManagement'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {DateStep} from '../../../../shared/order-editor/components/fields/Date'

/**
 * OrderManagement-specific wrapper for DateStep.
 * Uses changeable field hook to display banner when date changes require dispatch approval.
 */
export const OrderManagementDateStep: React.FC = () => {
  const {t} = useTranslation()
  const {processData} = useOrderChangeContext()
  // For an unconfirmed UE/CC order with a non-zero offset, floor the first selectable date at the
  // rescheduled delivery date (matching OnSite).
  const minimumDate = getUeCcVariationCodeAdjustedTime(processData)

  // Get changeable field state for date
  const {state} = useChangeableField({
    field: 'dateTime',
    fieldPart: 'date'
  })

  const requiresDispatchConfirmation = state === 'requireDispatchConfirmation'

  const bannerText = useMemo(() => {
    // Show banner when the field is dirty and requires dispatch confirmation
    if (requiresDispatchConfirmation) {
      return t(
        'orderIntake.rmc.orderManagement.dateChange.approvalWarning',
        'Date changes close to the delivery date need to be approved by dispatch.'
      )
    }

    return undefined
  }, [requiresDispatchConfirmation, t])

  return <DateStep bannerText={bannerText} minimumDate={minimumDate} />
}
